import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibDeleteFillIcon, KibVisibilityOnIcon } from '@chewy/kib-icons-react'
import classNames from 'classnames'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import styles from './RhapKibAttachmentsList.module.scss'

export interface AttachmentFile {
  id: string
  name: string
  originalFileName?: string
}

interface RhapKibAttachmentsListProps<T extends AttachmentFile> {
  className?: string
  files: T[]
  isDeleting?: boolean
  onDelete?: (file: T) => void
  onPreview: (file: T) => void
  readOnly?: boolean
}

export const RhapKibAttachmentsList = <T extends AttachmentFile>({
  className,
  files,
  isDeleting = false,
  readOnly = false,
  onPreview,
  onDelete,
}: RhapKibAttachmentsListProps<T>) => {
  const { t } = useTranslation()

  if (files.length === 0) {
    return null
  }

  return (
    <div
      className={classNames(className, styles.attachments, {
        [styles.attachmentsReadOnly]: readOnly,
      })}
    >
      <h5 className={styles.attachmentsTitle}>
        {t('Common:ATTACHMENTS')} ({files.length})
      </h5>
      <div className={styles.attachmentsList}>
        {files.map((file) => (
          <div className={styles.attachmentItem} key={file.id}>
            <span className={styles.attachmentName}>
              {file.originalFileName}
            </span>
            <span className={styles.buttonGroup}>
              <KibButtonNew
                iconOnly
                disabled={isDeleting}
                icon={<KibVisibilityOnIcon />}
                size="small"
                theme="utility"
                onClick={() => onPreview(file)}
              />
              {!readOnly && onDelete && (
                <KibButtonNew
                  iconOnly
                  disabled={isDeleting}
                  icon={<KibDeleteFillIcon />}
                  loading={isDeleting}
                  size="small"
                  theme="utility"
                  onClick={() => onDelete(file)}
                />
              )}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
